"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const getAverage = (props) => {
    if ((0, lodash_1.isNil)(props.runs))
        props.runs = 0;
    if ((0, lodash_1.isNil)(props.inningsCount))
        props.inningsCount = 0;
    if ((0, lodash_1.isNil)(props.notOuts))
        props.notOuts = 0;
    let outInningsCount = props.inningsCount - props.notOuts;
    let avg = null;
    if (props.runs > 0 && outInningsCount > 0) {
        avg = Number((props.runs / outInningsCount).toFixed(2));
    }
    else if (props.runs > 0) {
        avg = props.runs;
    }
    return avg;
};
exports.default = getAverage;
//# sourceMappingURL=getAverage.js.map